import type { ThemeConfig } from "antd";

// ──────────────────────────────────────────────────────────────────────────
// Vion Cloud-inspired palette
//   Primary   — Amber/Gold       #f6b000  (fire-gradient start)
//   Accent    — Orange-red fire  #ff3d06  (fire-gradient end)
//   Error     — Coral red        #ff4040
//   Success   — Vion green       #33ce39
//   Warning   — Amber            #f6b000 (= primary, by design)
//   Text      — Slate ink        #1a202c / #2d3748 / #4a5568 / #718096
//   Surface   — White on #f7f8fa  (warm-neutral layout background)
//   Sidebar   — Deep slate       #1a202c  (with gradient sheen)
// ──────────────────────────────────────────────────────────────────────────

export const wansightTheme: ThemeConfig = {
  token: {
    colorPrimary: "#f6b000",
    colorInfo:    "#ff3d06",
    colorLink:    "#ff3d06",
    colorSuccess: "#33ce39",
    colorWarning: "#f6b000",
    colorError:   "#ff4040",

    borderRadius:   10,
    borderRadiusLG: 14,
    borderRadiusSM: 6,
    borderRadiusXS: 4,

    colorBorder:          "#e5e7eb",
    colorBorderSecondary: "#f1f2f4",
    colorBgLayout:        "#f7f8fa",
    colorBgContainer:     "#ffffff",
    colorText:            "#2d3748",
    colorTextSecondary:   "#718096",
    colorTextHeading:     "#1a202c",

    fontFamily:
      'Poppins, "SVN-Poppins", Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize:         13,
    fontSizeHeading1: 32,
    fontSizeHeading2: 24,
    fontSizeHeading3: 19,
    fontSizeHeading4: 16,
    fontSizeHeading5: 14,
    lineHeight:       1.55,
    controlHeight:    34,
    controlHeightSM:  28,
  },
  components: {
    Layout: {
      headerBg:      "#1a202c",
      headerHeight:  52,
      headerPadding: "0 24px",
      siderBg:       "#1a202c",
      bodyBg:        "#f7f8fa",
      footerBg:      "#f1f2f4",
      footerPadding: "10px 24px",
    },
    Menu: {
      itemBg:             "transparent",
      itemColor:          "#a0aec0",
      itemSelectedBg:     "rgba(246,176,0,0.14)",
      itemSelectedColor:  "#f6b000",
      itemHoverBg:        "rgba(255,255,255,0.05)",
      itemHoverColor:     "#edf2f7",
      itemHeight:         38,
      iconSize:           14,
      groupTitleColor:    "#4a5568",
      groupTitleFontSize: 10,
    },
    Card: {
      headerBg:       "#ffffff",
      headerHeight:   44,
      headerFontSize: 14,
      paddingLG:      18,
      borderRadiusLG: 14,
    },
    Table: {
      headerBg:            "#fafbfc",
      headerColor:         "#4a5568",
      headerSplitColor:    "#edf0f3",
      borderColor:         "#f1f2f4",
      rowHoverBg:          "#fff7ed",
      cellPaddingBlock:    9,
      cellPaddingInline:   12,
      cellPaddingBlockSM:  6,
      cellPaddingInlineSM: 8,
      cellFontSize:        13,
    },
    Button: {
      controlHeight:   34,
      controlHeightSM: 28,
      fontSize:        13,
      paddingInline:   16,
      fontWeight:      600,
      primaryShadow:   "0 6px 16px rgba(246,176,0,0.28)",
    },
    Input: {
      controlHeight: 34,
      paddingInline: 12,
      activeBorderColor: "#f6b000",
      hoverBorderColor:  "#fdb833",
    },
    Select: {
      controlHeight: 34,
    },
    Modal: {
      headerBg:      "#ffffff",
      titleFontSize: 15,
      titleColor:    "#1a202c",
      contentBg:     "#ffffff",
      borderRadiusLG: 14,
    },
    Form: {
      itemMarginBottom:     16,
      labelFontSize:        13,
      verticalLabelPadding: "0 0 4px",
    },
    Tabs: {
      titleFontSize:         13,
      horizontalItemPadding: "8px 18px",
      inkBarColor:           "#ff3d06",
      itemSelectedColor:     "#ff3d06",
      itemHoverColor:        "#f6b000",
    },
    Tag: {
      defaultBg:      "#fff7ed",
      defaultColor:   "#9a3412",
      borderRadiusSM: 4,
    },
    Statistic: {
      titleFontSize:   12,
      contentFontSize: 28,
    },
    Badge: {
      statusSize: 7,
    },
    Progress: {
      defaultColor: "#f6b000",
    },
  },
};
